// Vendors
import React, { useState, useEffect } from 'react';
import axios from 'axios';

// Components
import { Loader } from '../../../components';

const Appliances = ({
  projectData,
  handleInputChange,
  handleChangeView,
  handleSaveProject,
  updateSpecificProjectDataProperty,
  fields,
  setFields
}) => {
  const [loading, setLoading] = useState(false);
  const [totalIncentive, setTotalIncentive] = useState(
    projectData.appliance_total_incentives ?? 0
  );
  const [region, setRegion] = useState(null);
  const [qualifyingAppliances, setQualifyingAppliances] = useState([]);
  const [newConstructionRegionBonus, setNewConstructionRegionBonus] = useState(0);
  const [bonusAppliance, setBonusAppliance] = useState(null);
  const [error, setError] = useState(null);

  // State bonus related states
  const [qualifyingStateBonus, setQualifyingStateBonus] = useState({});
  const [stateBonus, setStateBonus] = useState(0);
  const [stateRemainingFunds, setStateRemainingFunds] = useState(null);

  const { construction_type } = projectData;
  let _isSubscribed = true;

  const changedFromAppliances = [
    'cooktop_range',
    'oven',
    'clothes_dryer',
    'standby_generator',
    'fireplace_gas_log',
    'piping_propane_gas',
    'furnace'
  ];

  const handleCheckBoxChange = (event) => {
    const propName = event.currentTarget.name;
    const appliance = propName.substring(propName.indexOf('_') + 1);

    // Determine if adding or removing the appliance
    const sum = projectData[propName] > 0 ? -1 : 1;

    // Handle state bonus before changing data
    handleStateBonusAmount(propName, sum);

    // Clear changed from value if appliance is unchecked
    if (changedFromAppliances.includes(appliance) && projectData[propName] > 0) {
      const key = `${propName}_changed_from`;
      updateSpecificProjectDataProperty(key, '');
    }

    updateSpecificProjectDataProperty(
      propName,
      projectData[propName] > 0 ? 0 : 1
    );

    getNewConstructionRegionalBonus();
    getTotalIncentiveAmount();
  };

  const handleCountChange = (propName, sum) => {
    let newVal = parseInt(projectData[propName]) || 0;
    if (sum > 0) {
      newVal += 1;
    } else {
      newVal -= 1;
      newVal = newVal >= 0 ? newVal : 0;
    }

    if (projectData[propName] === '') {
      return;
    }

    handleStateBonusAmount(propName, sum);
    updateSpecificProjectDataProperty(propName, newVal);
    getNewConstructionRegionalBonus();
    getTotalIncentiveAmount();
  };

const handleStateBonusAmount = (prop, sum) => {
    // get total cost of one of whatever was passed in;
    if (qualifyingStateBonus.hasOwnProperty(prop))
    {
      let cost = fields[0].fields.find(item => item.meta_name === prop);
      let bonusDifference = sum > 0 ? parseInt(qualifyingStateBonus[prop]) : sum < 0 ? -1 * parseInt(qualifyingStateBonus[prop]) : 0;

      let newBonus = stateBonus + bonusDifference;

      // if at 0, don't deduct
      if (sum < 0 && stateBonus === 0)
      {
        return;
      }

      // if increasing and theres's a remainder
      if (sum > 0 && stateRemainingFunds > 0 && stateRemainingFunds - bonusDifference < 0)
      {
        setStateRemainingFunds(stateRemainingFunds - bonusDifference);
        setStateBonus(stateBonus + stateRemainingFunds);
        updateSpecificProjectDataProperty('appliance_state_bonus', stateBonus + stateRemainingFunds);
        return;
      }

      //
      if (sum < 0 && stateRemainingFunds <= 0 && stateRemainingFunds - bonusDifference > 0)
      {
        setStateRemainingFunds(stateRemainingFunds - bonusDifference);
        setStateBonus(stateBonus - stateRemainingFunds + bonusDifference);
        updateSpecificProjectDataProperty('appliance_state_bonus', stateBonus - stateRemainingFunds + bonusDifference);
        return;
      }

      // if decreasing but there's a negative remaining funds
      if (sum < 0 && stateRemainingFunds - bonusDifference > 0)
      {
        setStateRemainingFunds(stateRemainingFunds - bonusDifference);
        setStateBonus(stateBonus + bonusDifference);
        updateSpecificProjectDataProperty('appliance_state_bonus', stateBonus + bonusDifference);
        return;
      }
      if (stateRemainingFunds <= 0)
      {
        setStateRemainingFunds(stateRemainingFunds - bonusDifference);
        return;
      }
      setStateRemainingFunds(stateRemainingFunds - bonusDifference);
      setStateBonus(newBonus);
      updateSpecificProjectDataProperty('appliance_state_bonus', newBonus);
    }
  };


  const getNewConstructionRegionalBonus = () => {
    // Only applies to 'New' constructions.
    if (construction_type !== 'New') {
      setNewConstructionRegionBonus(0);
      setBonusAppliance(null);
      return;
    }

    let bonusApplianceName = '';

    // Check if builder has a qualifying appliance selected.
    const qualifies = Object.entries(qualifyingAppliances).some(
      ([name, metaName]) => {
        if (projectData[metaName] > 0) {
          bonusApplianceName = name;
          return true;
        }
        return false;
      }
    );

    // Bonus is $500 max, regardless of the number of qualifying appliances selected.
    setNewConstructionRegionBonus(qualifies ? 500 : 0);
    setBonusAppliance(bonusApplianceName);
  };


  const getStateRemainingFunds = (total) => {
    setStateRemainingFunds((prevFunds) => {
      if (prevFunds === null) {
        console.log("State remaining funds is null!");
        return prevFunds;
      }
      return prevFunds - total;
    });
  };

  const getTotalStateBonusAmount = () => {
    if (fields && !Object.keys(fields).length) return;

    const requiredApplianceFields = fields[0].fields;
    const additionalApplianceFields = fields[1].fields;

    if (!qualifyingStateBonus || !Object.keys(qualifyingStateBonus).length)
    {
      console.log("qualifying state bonus fields are empty");
      return;
    }
    console.log("getting state bonus amount");
    var total = 0;

    requiredApplianceFields.map(({ meta_name, amount }) => {
      const applianceCount = projectData[meta_name];

      if (applianceCount > 0 && qualifyingStateBonus.hasOwnProperty(meta_name)) {
        total += qualifyingStateBonus[meta_name] * applianceCount;
      }
    });

    additionalApplianceFields.map(({ meta_name, amount }) => {
      const applianceCount = projectData[meta_name];

      if (applianceCount > 0 && qualifyingStateBonus.hasOwnProperty(meta_name)) {
        total += qualifyingStateBonus[meta_name] * applianceCount;
      }
    });


    if (total > stateRemainingFunds) {
      setStateBonus(stateRemainingFunds);
      return total;
    } else {
      setStateBonus(total);
      return total;
    }
    //setStateBonus(total);
    //return total
  };

  const getIsEligibleForIncentive = () => {
    let hasWaterHeaterOrBoiler = false;
    const requiredApplianceFields = fields[0].fields;
    const additionalApplianceFields = fields[1].fields;

    var count = requiredApplianceFields.reduce((acc, item) => {
      const applianceCount = Number(projectData[item.meta_name] || 0);
      // Check if this appliance is a boiler or water heater and has been selected.
      if (applianceCount > 0) {
        hasWaterHeaterOrBoiler = true;
      }
      return acc + applianceCount;
    }, 0);
    count += additionalApplianceFields.reduce((acc, item) => {
      const applianceCount = Number(projectData[item.meta_name] || 0);
      return acc + applianceCount;
    }, 0);
    return hasWaterHeaterOrBoiler && count > 1;
  };

  const getTotalIncentiveAmount = () => {
    if (fields && !Object.keys(fields).length) return;

    const requiredApplianceFields = fields[0].fields;
    const additionalApplianceFields = fields[1].fields;
    let requiredFieldsTotal = 0;
    let additionalFieldsTotal = 0;
    let remodelFieldsTotal = 0;
    let grandTotal = 0;

    requiredApplianceFields.map(({ meta_name, amount }) => {
      const applianceCount = projectData[meta_name];

      if (applianceCount > 0) {
        requiredFieldsTotal += amount * applianceCount;
      }
    });

    additionalApplianceFields.map(({ meta_name, amount }) => {
      const applianceCount = projectData[meta_name];

      if (applianceCount > 0) {
        additionalFieldsTotal += amount * applianceCount;
      }
    });

    if (construction_type == 'Remodel') {
      remodelFieldsTotal = projectData['appliance_remodel_changed_from_fuel_type'] !== undefined
        && projectData['appliance_remodel_changed_from_fuel_type'] !== '' ? 500 : 0;
    }

    grandTotal = requiredFieldsTotal + additionalFieldsTotal;
    grandTotal = grandTotal > 1000 ? 1000 : grandTotal;

    if (construction_type == 'New') {
      grandTotal += newConstructionRegionBonus;
    } else {
      grandTotal += remodelFieldsTotal;
    }

    // Reset to 0 if no required appliances were selected.
    if (requiredFieldsTotal === 0) {
      grandTotal = 0;
    }

    var isEl = getIsEligibleForIncentive()
    if (isEl) {
      setTotalIncentive(grandTotal);
      updateSpecificProjectDataProperty('appliance_total_incentives', grandTotal);
    } else {
      setTotalIncentive(0);
      updateSpecificProjectDataProperty('appliance_total_incentives', 0);
    }

    setTotalIncentive(grandTotal);
    updateSpecificProjectDataProperty('appliance_total_incentives', grandTotal);
  };


  const getSelectedRemodelAppliances = (index) => {
    // now return if in the additional appliances section
    // we just want to display the dropdown for the main appliances
    if (index === 1) return;
    const selectedRemodelAppliances = fields[index]?.fields?.filter(({ meta_name }) => {
      const projectDataProp = parseInt(projectData[meta_name]) || 0;
      return projectDataProp > 0;
    }) || [];

    if (!selectedRemodelAppliances.length) {
      return null;
    }

    return (
      <div className="appliance-form__remodel-block">
        {/* First dropdown: Did you change to propane gas? */}
        <div className="form__field appliance-form__item">
          <label htmlFor="appliane_remodel_changed_to_propane">
            Did you change to propane gas?
          </label>
          <div className="form__select form__select--no-shadow">
            <select
              id="appliance_remodel_changed_to_propane"
              name="appliance_remodel_changed_to_propane"
              value={projectData["appliance_remodel_changed_to_propane"]}
              onChange={(event) => {
                handleInputChange(event);
                getTotalIncentiveAmount();
              }}
            >
              <option value="">--Select--</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>
        </div>

        {/* Second dropdown: only show if user selected "Yes" above */}
        {projectData["appliance_remodel_changed_to_propane"] === "yes" && (
          <div className="form__field appliance-form__item u--margin-top-10">
            <label htmlFor="appliance_remodel_changed_from_fuel_type">
              Which fuel type did you switch from?
            </label>
            <div className="form__select form__select--no-shadow">
              <select
                id="appliance_remodel_changed_from_fuel_type"
                name="appliance_remodel_changed_from_fuel_type"
                value={projectData["appliance_remodel_changed_from_fuel_type"]}
                onChange={(event) => {
                  handleInputChange(event);
                  getTotalIncentiveAmount();
                }}
              >
                <option value="">
                  -- Select fuel type that was switched from --
                </option>
                <option value="Oil">Oil to Propane</option>
                <option value="Electricity">Electricity to Propane</option>
              </select>
            </div>
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    setLoading(true);
    _isSubscribed = true;

    const formData = new FormData();
    formData.append('action', 'wl_pip_get_appliances_fields');
    formData.append('state', projectData.state);
    formData.append('construction_type', construction_type);

    axios({
      method: 'post',
      url: window.wlPipConfig.ajaxUrl,
      data: formData
    })
      .then(
        ({
          data: {
            success,
            data: { fields, region, qualifying, state_bonus, remaining_state_funds }
          }
        }) => {
          if (_isSubscribed) {
            if (success && fields) {
              setFields(fields);
              setRegion(region);
              let rem = remaining_state_funds ? parseInt(remaining_state_funds) : 0;
              rem = projectData['appliance_state_bonus'] ? (rem + parseInt(projectData['appliance_state_bonus'])) : rem;
              setStateRemainingFunds(rem);
              if (Object.keys(state_bonus).length) {
                setQualifyingStateBonus(state_bonus);
              }

              if (Object.keys(qualifying).length) {
                setQualifyingAppliances({ ...qualifying });
              }
            }

            setTimeout(() => setLoading(false), 100);
            _isSubscribed = false;
          }
        }
      )
      .catch((error) => {
        console.log(error);

        setLoading(false);
      });

    return () => (_isSubscribed = false);
  }, [projectData.state, construction_type]);

  useEffect(() => {
    getNewConstructionRegionalBonus();
    let total = getTotalStateBonusAmount();
    getStateRemainingFunds(total);

    getTotalIncentiveAmount();
  }, [construction_type, qualifyingAppliances]);

  useEffect(() => {
      // let total = getTotalStateBonusAmount();
      // getStateRemainingFunds(total);
      getTotalIncentiveAmount();
  }, [newConstructionRegionBonus]);

  const checkHasTwoSelections = () => {
    if (!fields || (fields && !Object.keys(fields).length)) return;
    const requiredApplianceFields = fields[0].fields;
    const additionalApplianceFields = fields[1].fields;

    var count = requiredApplianceFields.reduce((acc, item) => {
      const applianceCount = Number(projectData[item.meta_name] || 0);
      // Check if this appliance is a boiler or water heater and has been selected.
      return acc + applianceCount;
    }, 0);
    count += additionalApplianceFields.reduce((acc, item) => {
      const applianceCount = Number(projectData[item.meta_name] || 0);
      return acc + applianceCount;
    }, 0);
    return count > 1;
  };

  const handleSaveAppliancesSection = () => {
    const hasTwoSelections = checkHasTwoSelections();
    if (projectData.appliance_attestation != 1) {
      setError("Appliance Attestation is required.");
      return;
    } else if (!hasTwoSelections) {
      setError("Two selections are required.");
      return;
    }

    handleSaveProject(fields);
  };

  if (loading || !Object.keys(fields).length) return <Loader />;

  return (
    <div id="pip-appliances" style={{ maxWidth: '900px' }}>
      <div className="appliance-form u--font-size-lg">
        {Object.entries(fields).map(([key, field_section], index) => {
          if (index === 2) return null;

          const formRows = field_section.fields.map(
            ({ meta_name, label, amount }, idx) => {
              const projectDataProp = projectData[meta_name];

              return (
                <div key={idx} className="appliance-form__row">
                  <div className="form__field appliance-form__item">
                    <label className="form__checkbox" htmlFor={meta_name}>
                      <input
                        id={meta_name}
                        type="checkbox"
                        name={meta_name}
                        checked={projectDataProp > 0}
                        onChange={handleCheckBoxChange}
                      />{' '}
                      {label}
                    </label>
                  </div>
                  <div
                    className={`appliance-form__count ${
                      projectDataProp > 0 ? 'appliance-form__count--show' : ''
                    }`}
                  >
                    <button
                      className="btn appliance-form__count__change"
                      onClick={() => handleCountChange(meta_name, -1)}
                    >
                      &ndash;
                    </button>
                    <span className="appliance-form__count__number">
                      {projectDataProp}
                    </span>
                    <button
                      className="btn appliance-form__count__change"
                      onClick={() => handleCountChange(meta_name, 1)}
                    >
                      +
                    </button>
                  </div>
                  <div className="appliance-form__amount">${amount}</div>
                </div>
              );
            }
          );

          return (
            <div key={index}>
              <p
                dangerouslySetInnerHTML={{ __html: field_section.intro }}
                className="u--margin-bottom-10"
              />
              {formRows}
              <hr />
              {construction_type === 'Remodel' && index < 2 && (
                <>
                  {getSelectedRemodelAppliances(index)}
                  <hr />
                </>
              )}
            </div>
          );
        })}

        {/* New bonus message, if applicable */}
        {construction_type === 'New' && bonusAppliance && region && (
          <div className="notice notice--success" role="alert">
            Your selection of {bonusAppliance} automatically qualifies you for the
            $500 {region} bonus.
          </div>
        )}

        <div className="appliance-form__row">
          <div className="form__field appliance-form__item">
            <p>
              <strong>Appliance Attestation:</strong>
            </p>
            <label
              className={`form__label form__checkbox ${
                error !== null ? 'u--color-red' : ''
              }`}
              htmlFor="appliance_attestation"
            >
              <input
                id="appliance_attestation"
                type="checkbox"
                name="appliance_attestation"
                className={`${error !== null ? 'u--border-color-red' : ''}`}
                checked={projectData.appliance_attestation > 0}
                onChange={(event) => {
                  setError(null);
                  updateSpecificProjectDataProperty(
                    'appliance_attestation',
                    projectData.appliance_attestation > 0 ? 0 : 1
                  );
                }}
              />{' '}
              I certify that the propane appliances selected in this application,
              for this address, have been installed. (required)
            </label>
          </div>
        </div>

        <hr />

        {stateBonus > 0 && (
          <div className="appliance-form__row u--margin-bottom-30">
            <span>State Bonus</span>
            <strong>
              {stateBonus > 0 ? `$${parseInt(stateBonus).toLocaleString()}` : '--'}
            </strong>
          </div>
        )}

        <div className="appliance-form__row u--margin-bottom-30">
          <span>Total Check</span>
          <strong>
            {parseInt(totalIncentive) > 0
              ? `$${(parseInt(totalIncentive) + parseInt(stateBonus)).toLocaleString()}`
              : '--'}
          </strong>
        </div>
        <p className="u--padding-left-10-xs-min">
          <a
            href="/pcrp/research/"
            title="Research Overview"
            className="btn btn--lg btn--blue btn--link btn--has-arrow module-hover-root"
          >
            <span className="btn__content">
              <span className="btn__text">View Research Details</span>
              <span className="btn__arrow arrow"></span>
            </span>
          </a>
        </p>
        {error !== null && (
          <div
            className={`notice notice--error u--margin-bottom-30`}
            role="alert"
            style={{ maxWidth: '600px' }}
          >
            {error}
          </div>
        )}
        <button
          id="pip-add__save-epat"
          className={`btn btn--gold btn--lg module-hover-root ${
            loading ? 'btn--loading' : ''
          }`}
          type="button"
          onClick={handleSaveAppliancesSection}
          disabled={loading || error !== null || projectData['status'] !== 'In Progress' || !getIsEligibleForIncentive()}
        >
          <span className="btn__content">
            <span className="btn__text">Save Appliances</span>
          </span>
        </button>
        <span
          className="btn btn--white btn--lg module-hover-root u--margin-left-30"
          onClick={() => handleChangeView('project-form')}
        >
          <span className="btn__content">
            <span className="btn__text">Back to Project Overview</span>
          </span>
        </span>
      </div>
    </div>
  );
};

export default Appliances;
